import DtoAccountStatistic from './DtoAccountStatistic'

export default class DtoAccountStationStatistic extends DtoAccountStatistic {
    constructor(obj) {
        super(obj)
    }
}